"use client";

import { ChakraProvider } from "@chakra-ui/react";
import { FC, PropsWithChildren } from "react";
import system from "../../theme";

const ThemeProvider: FC<PropsWithChildren> = ({ children }) => (
  <ChakraProvider value={system}>{children}</ChakraProvider>
);

export default ThemeProvider;
